export default class BatchEndMemberClubFees {
    static ACTION_NAME = 'EndMemberClubFees';

    constructor() {
        this.action = BatchEndMemberClubFees.ACTION_NAME;
        this.entity = 'MemberClubFee';
        this.endDate = null;
        this.ids = [];
    }

    serialize() {
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            endDate: this.endDate,
        };
    }

    isValid() {
        return !!this.endDate && !!this.ids && this.ids.length > 0;
    }
}
